var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataIdentity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9340_15972)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_9340_15972)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8953 12.1416C15.1809 12.1416 13.7516 13.4872 13.7516 15.1949C13.7516 16.9025 15.1808 18.2481 16.8953 18.2481C18.6098 18.2481 20.0391 16.9025 20.0391 15.1949C20.0391 13.4872 18.6098 12.1416 16.8953 12.1416ZM15.0016 15.1949C15.0016 14.2203 15.8277 13.3916 16.8953 13.3916C17.9629 13.3916 18.7891 14.2203 18.7891 15.1949C18.7891 16.1694 17.9629 16.9981 16.8953 16.9981C15.8277 16.9981 15.0016 16.1694 15.0016 15.1949ZM12.9868 21.5091C12.9868 21.3392 13.1363 21.1628 13.3693 21.1628H21.4292C21.7744 21.1628 22.0542 20.883 22.0542 20.5378C22.0542 20.1926 21.7744 19.9128 21.4292 19.9128H13.3693C12.4894 19.9128 11.7368 20.6061 11.7368 21.5091V26.8513C11.7368 29.6318 14.0682 31.8471 16.8955 31.8471C17.869 31.8471 18.7823 31.5854 19.5618 31.129C19.8596 30.9545 19.9597 30.5717 19.7852 30.2738C19.6108 29.9759 19.2279 29.8759 18.9301 30.0503C18.3388 30.3966 17.643 30.5971 16.8955 30.5971C14.7151 30.5971 12.9868 28.8987 12.9868 26.8513V21.5091ZM26.0029 22.1519C23.6622 22.1519 21.7646 24.0494 21.7646 26.3901C21.7646 28.7309 23.6622 30.6284 26.0029 30.6284C28.3437 30.6284 30.2412 28.7309 30.2412 26.3901C30.2412 26.045 30.521 25.7651 30.8662 25.7651C31.2114 25.7651 31.4912 26.045 31.4912 26.3901C31.4912 29.4212 29.034 31.8784 26.0029 31.8784C22.9718 31.8784 20.5146 29.4212 20.5146 26.3901C20.5146 23.359 22.9718 20.9019 26.0029 20.9019C26.8943 20.9019 27.7377 21.1148 28.4834 21.4932C28.7912 21.6494 28.9141 22.0256 28.7579 22.3334C28.6018 22.6412 28.2256 22.7641 27.9178 22.6079C27.3433 22.3164 26.6933 22.1519 26.0029 22.1519ZM31.1177 23.5755C31.3618 23.3314 31.3618 22.9357 31.1177 22.6916C30.8736 22.4475 30.4779 22.4475 30.2338 22.6916L25.8359 27.0895L24.3317 25.5853C24.0876 25.3412 23.6919 25.3412 23.4478 25.5853C23.2038 25.8294 23.2038 26.2251 23.4478 26.4692L25.394 28.4153C25.6381 28.6594 26.0338 28.6594 26.2779 28.4153L31.1177 23.5755Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9340_15972",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9340_15972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIdentity);
export default __webpack_public_path__ + "static/media/data-identity.074d5ae2dc24036bbe6dc42fd708fd32.svg";
export { ForwardRef as ReactComponent };